<template>
  <div v-if="noticeVisible" class="cookie-notice">
      <el-row>
        <el-col>
          <p>{{t('bodyText.label')}}
            <i18n-t keypath="linkToPrivacyPolicy.label" tag="span">
              <a target="_blank" :href="routerToPrivacyPolicy || 'https://www.dutypay.eu/de/datenschutz.html'">{{t('privacyPolicy.label')}}</a>
            </i18n-t>
          </p>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around" :gutter="25" align="middle" class="buttons-container">
        <el-col>
          <dp-button purpose="secondary" small v-on:click="denyGDPR">{{t('buttonDeny.buttonLabel')}}</dp-button>
        </el-col>
        <el-col align="right">
          <dp-button purpose="primary" small v-on:click="acceptGDPR">{{t('buttonAgree.buttonLabel')}}</dp-button>
        </el-col>
      </el-row>
  </div>
</template>

<script setup>
// TODO: Status undetermined
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<script>
  export default {
    name: "CookieNotice",
    props: {
      routerToPrivacyPolicy: {
        type: String
      }
    },
    data() {
      return {
        noticeVisible: false,
      };
    },
    created() {
      if (!this.getAcceptStatus() === true) {
        this.noticeVisible = true;
      }
    },
    methods: {
      setAccept() {
        // if (typeof (Storage) !== "undefined") {
        localStorage.setItem('dp-gdpr:cookie', true);
        // }
      },
      setDeny() {
        // if (typeof (Storage) !== "undefined") {
        localStorage.setItem('dp-gdpr:cookie', false);
        // }
      },
      getAcceptStatus() {
        // if (typeof (Storage) !== "undefined") {
        return localStorage.getItem('dp-gdpr:cookie');
        // }
      },
      acceptGDPR() {
        this.setAccept();
        this.noticeVisible = false;
        this.$emit('accept');
      },
      denyGDPR() {
        this.setDeny();
        this.noticeVisible = false;
        this.$emit('deny');
      }
    }
  };
</script>

<style scoped lang="scss">
  .cookie-notice {
    max-width: 38%;
    position: fixed;
    z-index: 4000;
    bottom: 25px;
    right: 25px;
    padding: 30px 35px;
    background-color: #ffffff;
    border: 2px solid #E3E3E3;
    $border-radius: 15px;
    -webkit-border-radius: $border-radius;
    -moz-border-radius: $border-radius;
    border-radius: $border-radius;
    $box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.18);
    -webkit-box-shadow: $box-shadow;
    -moz-box-shadow: $box-shadow;
    box-shadow: $box-shadow;
    overflow: hidden;
  }

  .buttons-container {
    margin-top: 25px;
  }

  @media screen and (max-width: 768px){
    .cookie-notice {
      max-width: 90%;
      left: 25px;
    }
  }

</style>

<i18n>
{
  "ar-AE": {
    "buttonAgree": {
      "buttonLabel": "يوافق على"
    },
    "buttonDeny": {
      "buttonLabel": "انخفاض"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "ar-EG": {
    "buttonAgree": {},
    "buttonDeny": {},
    "bodyText": {},
    "linkToPrivacyPolicy": {},
    "privacyPolicy": {}
  },
  "ar-SA": {
    "buttonAgree": {},
    "buttonDeny": {},
    "bodyText": {},
    "linkToPrivacyPolicy": {},
    "privacyPolicy": {}
  },
  "de-DE": {
    "buttonAgree": {
      "buttonLabel": "Zustimmen"
    },
    "buttonDeny": {
      "buttonLabel": "Ablehnen"
    },
    "bodyText": {
      "label": "ds.components.CookieNotice.bodyText.label"
    },
    "linkToPrivacyPolicy": {
      "label": "ds.components.CookieNotice.linkToPrivacyPolicy.label"
    },
    "privacyPolicy": {
      "label": "ds.components.CookieNotice.privacyPolicy.label"
    }
  },
  "de-AT": {
    "buttonAgree": {
      "buttonLabel": "Zustimmen"
    },
    "buttonDeny": {
      "buttonLabel": "Ablehnen"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "de-CH": {
    "buttonAgree": {
      "buttonLabel": "Zustimmen"
    },
    "buttonDeny": {
      "buttonLabel": "Ablehnen"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "en-US": {
    "buttonAgree": {
      "buttonLabel": "Agree"
    },
    "buttonDeny": {
      "buttonLabel": "Decline"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "en-GB": {
    "buttonAgree": {
      "buttonLabel": "Agree"
    },
    "buttonDeny": {
      "buttonLabel": "Decline"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "it-IT": {
    "buttonAgree": {
      "buttonLabel": "Essere d'accordo"
    },
    "buttonDeny": {
      "buttonLabel": "Declino"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "fr-FR": {
    "buttonAgree": {
      "buttonLabel": "Se mettre d'accord"
    },
    "buttonDeny": {
      "buttonLabel": "Déclin"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "es-ES": {
    "buttonAgree": {
      "buttonLabel": "De acuerdo"
    },
    "buttonDeny": {
      "buttonLabel": "Disminución"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "pl-PL": {
    "buttonAgree": {
      "buttonLabel": "Zgodzić się"
    },
    "buttonDeny": {
      "buttonLabel": "Upadek"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "nl-NL": {
    "buttonAgree": {
      "buttonLabel": "Mee eens"
    },
    "buttonDeny": {
      "buttonLabel": "Afwijzen"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "bg-BG": {
    "buttonAgree": {
      "buttonLabel": "Съгласен"
    },
    "buttonDeny": {
      "buttonLabel": "Отклонение"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "bs-BA": {
    "buttonAgree": {
      "buttonLabel": "Slažem se"
    },
    "buttonDeny": {
      "buttonLabel": "Odbij"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "da-DK": {
    "buttonAgree": {
      "buttonLabel": "Enig"
    },
    "buttonDeny": {
      "buttonLabel": "Nedgang"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "et-EE": {
    "buttonAgree": {
      "buttonLabel": "Nõus"
    },
    "buttonDeny": {
      "buttonLabel": "Keeldu"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "fi-FI": {
    "buttonAgree": {
      "buttonLabel": "Olla samaa mieltä"
    },
    "buttonDeny": {
      "buttonLabel": "Hylkää"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "el-GR": {
    "buttonAgree": {
      "buttonLabel": "Συμφωνώ"
    },
    "buttonDeny": {
      "buttonLabel": "Πτώση"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "he-IL": {
    "buttonAgree": {
      "buttonLabel": "לְהַסכִּים"
    },
    "buttonDeny": {
      "buttonLabel": "יְרִידָה"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "ga-IE": {
    "buttonAgree": {
      "buttonLabel": "Aontaigh"
    },
    "buttonDeny": {
      "buttonLabel": "Meath"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "ja-JP": {
    "buttonAgree": {
      "buttonLabel": "同意する"
    },
    "buttonDeny": {
      "buttonLabel": "低下"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "hr-HR": {
    "buttonAgree": {
      "buttonLabel": "Pristani"
    },
    "buttonDeny": {
      "buttonLabel": "Odbiti"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "lv-LV": {
    "buttonAgree": {
      "buttonLabel": "Piekrītu"
    },
    "buttonDeny": {
      "buttonLabel": "Noraidīt"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "lt-LT": {
    "buttonAgree": {
      "buttonLabel": "Sutikite"
    },
    "buttonDeny": {
      "buttonLabel": "Atmesti"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "pt-PT": {
    "buttonAgree": {
      "buttonLabel": "Aceita"
    },
    "buttonDeny": {
      "buttonLabel": "Declínio"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "ro-RO": {
    "buttonAgree": {
      "buttonLabel": "De acord"
    },
    "buttonDeny": {
      "buttonLabel": "Declin"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "ru-RU": {
    "buttonAgree": {
      "buttonLabel": "Согласен"
    },
    "buttonDeny": {
      "buttonLabel": "Отказаться"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "sv-SE": {
    "buttonAgree": {
      "buttonLabel": "Hålla med"
    },
    "buttonDeny": {
      "buttonLabel": "Nedgång"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "sk-SK": {
    "buttonAgree": {
      "buttonLabel": "Súhlasím"
    },
    "buttonDeny": {
      "buttonLabel": "Pokles"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "cs-CZ": {
    "buttonAgree": {
      "buttonLabel": "Souhlasit"
    },
    "buttonDeny": {
      "buttonLabel": "Pokles"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "tr-TR": {
    "buttonAgree": {
      "buttonLabel": "Katılıyorum"
    },
    "buttonDeny": {
      "buttonLabel": "Reddet"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "hu-HU": {
    "buttonAgree": {
      "buttonLabel": "Egyetért"
    },
    "buttonDeny": {
      "buttonLabel": "Hanyatlás"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "fr-BE": {
    "buttonAgree": {
      "buttonLabel": "Se mettre d'accord"
    },
    "buttonDeny": {
      "buttonLabel": "Déclin"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "fr-LU": {
    "buttonAgree": {
      "buttonLabel": "Se mettre d'accord"
    },
    "buttonDeny": {
      "buttonLabel": "Déclin"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "mt-MT": {
    "buttonAgree": {
      "buttonLabel": "Naqbel"
    },
    "buttonDeny": {
      "buttonLabel": "Tnaqqis"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "sl-SI": {
    "buttonAgree": {
      "buttonLabel": "Strinjam se"
    },
    "buttonDeny": {
      "buttonLabel": "Zavrni"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "el-CY": {
    "buttonAgree": {
      "buttonLabel": "Συμφωνώ"
    },
    "buttonDeny": {
      "buttonLabel": "Πτώση"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "tr-CY": {
    "buttonAgree": {
      "buttonLabel": "Katılıyorum"
    },
    "buttonDeny": {
      "buttonLabel": "Reddet"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  },
  "uk-UA": {
    "buttonAgree": {},
    "buttonDeny": {},
    "bodyText": {},
    "linkToPrivacyPolicy": {},
    "privacyPolicy": {}
  },
  "zh-CN": {
    "buttonAgree": {
      "buttonLabel": "同意"
    },
    "buttonDeny": {
      "buttonLabel": "下降"
    },
    "bodyText": {
      "label": ""
    },
    "linkToPrivacyPolicy": {
      "label": ""
    },
    "privacyPolicy": {
      "label": ""
    }
  }
}
</i18n>

